import { createFileRoute } from "@tanstack/react-router";
import { SparkSpreadDashboardView } from "@/components/SparkSpreadDashboard/SparkSpreadDashboardView";
import { readSparkspreadPricesApiV1SparkspreadGet } from "@/client/index";
import { checkPermission } from "@/lib/utils";

export const Route = createFileRoute("/_authenticated/sparkspread-dashboard")({
  component: SparkSpreadDashboardPage,
  beforeLoad: () => {
    checkPermission("sparkspread:read");
  },
});

export default function SparkSpreadDashboardPage() {
  return <SparkSpreadDashboardView queryKey={["spsp"]} queryFn={() => readSparkspreadPricesApiV1SparkspreadGet()} />;
}
